import type { TournamentGroup } from "@ssf/memdb-api";
import { format, isValid, parseISO } from "date-fns";

export type TournamentTimePoint = { date: string; time: string };
export type TournamentTimeRange = {
  start?: TournamentTimePoint;
  end?: TournamentTimePoint;
};

type GroupSchedule = Pick<
  TournamentGroup,
  "start" | "end" | "arenaStart" | "arenaEnd"
>;

const parseTimePoint = (date: string, time: string) => {
  if (!date || !time) return undefined;
  const parsed = parseISO(`${date}T${time}`);
  if (!isValid(parsed)) return undefined;
  return { date, time: format(parsed, "HH:mm") };
};

export const getTournamentTimeRange = (
  group?: GroupSchedule,
): TournamentTimeRange => {
  if (!group) return {};
  const start = parseTimePoint(group.start, group.arenaStart);
  const end = parseTimePoint(group.end, group.arenaEnd);
  return {
    start: start && { date: start.date, time: start.time },
    end: end && { date: end.date, time: end.time },
  };
};
